import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import VatDeadlineForm from '@/components/vat-deadlines/VatDeadlineForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVatDeadline',
  setup(__props) {

    const form = useForm({
        period: '',
        settlement_period_from: null,
        settlement_period_to: null,
        deadline: null,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.vat-deadlines.store'),
    "query-key": [_unref(QueryKey).VAT_DEADLINES],
    title: "system.add_vat_deadline",
    "button-text": "system.add_vat_deadline"
  }, {
    default: _withCtx(() => [
      _createVNode(VatDeadlineForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})